module.exports = __webpack_public_path__ + "static/media/MOWA.a409a2bc.png";